import $ from "jquery";

export const ToggleQrCodePage = () => {
    const $qrCodePage = $('#qr-code-page');
    const $closeBtn = $('.js-back-button');
    const $scanBtn = $('.home-map__icon-btn[aria-label="Scan"]');
    const $tabs = $('.qr-code-page__tab');
    const $myCodeView = $('#qr-view-my-code');
    const $scanCodeView = $('#qr-view-scan-code');

    $scanBtn.on('click', function () {
        $qrCodePage.addClass('active');
    });

    $closeBtn.on('click', function () {
        $qrCodePage.removeClass('active');
    });

    $tabs.on('click', function () {
        const view = this.dataset.view;
        $tabs.removeClass('qr-code-page__tab--active');
        $(this).addClass('qr-code-page__tab--active');
        if (view === 'my-code') {
            $myCodeView.addClass('active');
            $scanCodeView.removeClass('active');
        } else {
            $myCodeView.removeClass('active');
            $scanCodeView.addClass('active');
        }
    });
};